import React, { Component } from 'react';
import { STATUS_COLORS } from './shared/formatters';
import AuthService from '../AuthService';
import constants from '../../config';

var Auth = new AuthService();

var TYPE_COLORS = {
  charge: { bg: '#EFF6FF', text: '#1D4ED8', icon: 'fa-credit-card' },
  payout: { bg: '#ECFDF5', text: '#047857', icon: 'fa-arrow-right' },
  refund: { bg: '#FEF2F2', text: '#B91C1C', icon: 'fa-undo' },
  partial_refund: { bg: '#FFF7ED', text: '#C2410C', icon: 'fa-undo' },
};

class AdminPaymentLedger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      events: [],
      total: 0,
      page: 1,
      pages: 1,
      loading: true,
      typeFilter: '',
      methodFilter: '',
      dateFrom: '',
      dateTo: '',
    };
    this.fetchLedger = this.fetchLedger.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleExport = this.handleExport.bind(this);
  }

  componentDidMount() {
    this.fetchLedger();
  }

  fetchLedger(page) {
    var self = this;
    self.setState({ loading: true });
    var p = page || self.state.page;
    var params = new URLSearchParams();
    params.append('page', p);
    params.append('limit', 50);
    if (self.state.typeFilter) params.append('type', self.state.typeFilter);
    if (self.state.methodFilter) params.append('method', self.state.methodFilter);
    if (self.state.dateFrom) params.append('dateFrom', self.state.dateFrom);
    if (self.state.dateTo) params.append('dateTo', self.state.dateTo);

    Auth.fetch(constants.DOMAIN + '/api/v1/admin/payments/ledger?' + params.toString())
      .then(function(data) {
        self.setState({
          events: data.events || [],
          total: data.total || 0,
          page: data.page || 1,
          pages: data.pages || 1,
          loading: false,
        });
      })
      .catch(function(err) {
        console.log('Failed to fetch ledger:', err);
        self.setState({ loading: false });
      });
  }

  handleFilterChange(key, val) {
    var self = this;
    var update = {};
    update[key] = val;
    update.page = 1;
    self.setState(update, function() { self.fetchLedger(1); });
  }

  handleExport() {
    var headers = { 'Access-Control-Allow-Origin': '*' };
    if (Auth.loggedIn()) headers['Authorization'] = Auth.getAuthHeader();
    fetch(constants.DOMAIN + '/api/v1/admin/payments/export', { headers: headers })
      .then(function(res) {
        if (!res.ok) throw new Error('Export failed');
        return res.blob();
      })
      .then(function(blob) {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'payouts-' + new Date().toISOString().slice(0, 10) + '.csv';
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(function(err) { alert('Export failed: ' + (err.message || 'Unknown error')); });
  }

  render() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var events = this.state.events;

    return (
      <div>
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-6">
          <div>
            <h2 className="tw-text-xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">Payment Ledger</h2>
            <p className="tw-text-sm tw-text-[#999] tw-m-0 tw-mt-0.5">Chronological financial events</p>
          </div>
          <button
            onClick={this.handleExport}
            className="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-medium tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
            style={{ backgroundColor: '#10B981' }}
          >
            <i className="fa fa-download" /> Export CSV
          </button>
        </div>

        {/* Filters */}
        <div className="tw-rounded-xl tw-p-4 tw-mb-6" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
          <div className="tw-flex tw-flex-wrap tw-gap-3">
            <select
              value={this.state.typeFilter}
              onChange={function(e) { self.handleFilterChange('typeFilter', e.target.value); }}
              className="tw-px-3 tw-py-2 tw-rounded-lg tw-border tw-text-sm tw-bg-white dark:tw-bg-[#222] tw-text-[#1a1a1a] dark:tw-text-white tw-border-[#d0d0d0] dark:tw-border-[#555]"
              style={isDark ? { colorScheme: 'dark' } : {}}
            >
              <option value="">All Types</option>
              <option value="charge">Charges</option>
              <option value="payout">Payouts</option>
              <option value="refund">Refunds</option>
              <option value="partial_refund">Partial Refunds</option>
            </select>

            <select
              value={this.state.methodFilter}
              onChange={function(e) { self.handleFilterChange('methodFilter', e.target.value); }}
              className="tw-px-3 tw-py-2 tw-rounded-lg tw-border tw-text-sm tw-bg-white dark:tw-bg-[#222] tw-text-[#1a1a1a] dark:tw-text-white tw-border-[#d0d0d0] dark:tw-border-[#555]"
              style={isDark ? { colorScheme: 'dark' } : {}}
            >
              <option value="">All Methods</option>
              <option value="stripe">Stripe</option>
              <option value="paypal">PayPal</option>
            </select>

            <input
              type="date"
              value={this.state.dateFrom}
              onChange={function(e) { self.handleFilterChange('dateFrom', e.target.value); }}
              className="tw-px-3 tw-py-2 tw-rounded-lg tw-border tw-text-sm tw-bg-white dark:tw-bg-[#222] tw-text-[#1a1a1a] dark:tw-text-white tw-border-[#d0d0d0] dark:tw-border-[#555]"
              style={isDark ? { colorScheme: 'dark' } : {}}
              placeholder="From"
            />

            <input
              type="date"
              value={this.state.dateTo}
              onChange={function(e) { self.handleFilterChange('dateTo', e.target.value); }}
              className="tw-px-3 tw-py-2 tw-rounded-lg tw-border tw-text-sm tw-bg-white dark:tw-bg-[#222] tw-text-[#1a1a1a] dark:tw-text-white tw-border-[#d0d0d0] dark:tw-border-[#555]"
              style={isDark ? { colorScheme: 'dark' } : {}}
              placeholder="To"
            />

            {(this.state.typeFilter || this.state.methodFilter || this.state.dateFrom || this.state.dateTo) && (
              <button
                onClick={function() { self.setState({ typeFilter: '', methodFilter: '', dateFrom: '', dateTo: '', page: 1 }, function() { self.fetchLedger(1); }); }}
                className="tw-px-3 tw-py-2 tw-rounded-lg tw-text-sm tw-text-[#999] hover:tw-text-[#666] tw-bg-transparent tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-cursor-pointer"
              >
                Clear
              </button>
            )}
          </div>
        </div>

        {this.state.loading ? (
          <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
            <div className="tw-text-center">
              <i className="fa fa-circle-o-notch fa-spin tw-text-3xl tw-mb-3" style={{ color: '#D4A843', display: 'block' }} />
              <span className="tw-text-sm tw-text-[#999]">Loading...</span>
            </div>
          </div>
        ) : events.length === 0 ? (
          <div className="tw-rounded-xl tw-p-12 tw-text-center" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
            <i className="fa fa-inbox tw-text-4xl tw-text-[#ccc] tw-mb-3" style={{ display: 'block' }} />
            <p className="tw-text-sm tw-text-[#999] tw-m-0">No financial events found</p>
          </div>
        ) : (
          <div>
            {/* Events Table */}
            <div className="tw-rounded-xl tw-overflow-hidden" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
              <div className="tw-overflow-x-auto">
                <table className="tw-w-full tw-text-sm" style={{ minWidth: '600px' }}>
                  <thead>
                    <tr style={{ backgroundColor: isDark ? '#111' : '#fafafa' }}>
                      <th className="tw-px-4 tw-py-2.5 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase">Date</th>
                      <th className="tw-px-4 tw-py-2.5 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase">Type</th>
                      <th className="tw-px-4 tw-py-2.5 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-hidden md:tw-table-cell">Item</th>
                      <th className="tw-px-4 tw-py-2.5 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-hidden sm:tw-table-cell">Buyer</th>
                      <th className="tw-px-4 tw-py-2.5 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-hidden sm:tw-table-cell">Seller</th>
                      <th className="tw-px-4 tw-py-2.5 tw-text-right tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase">Amount</th>
                      <th className="tw-px-4 tw-py-2.5 tw-text-center tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase">Method</th>
                      <th className="tw-px-4 tw-py-2.5 tw-text-center tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-hidden lg:tw-table-cell">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {events.map(function(ev) {
                      var typeInfo = TYPE_COLORS[ev.type] || TYPE_COLORS.charge;
                      var typeLabel = ev.type === 'partial_refund' ? 'Partial Refund' : ev.type.charAt(0).toUpperCase() + ev.type.slice(1);
                      var amount = ev.type === 'payout' ? ev.sellerPayout : ev.type === 'partial_refund' ? ev.partialRefundAmount : ev.amount;
                      var statusColors = STATUS_COLORS[ev.payoutStatus] || STATUS_COLORS.held;

                      return (
                        <tr key={ev._id} className="tw-border-t tw-border-[#f0f0f0] dark:tw-border-[#222] hover:tw-bg-[#fafafa] dark:hover:tw-bg-[#1e1e1e]">
                          <td className="tw-px-4 tw-py-3 tw-text-[#666] dark:tw-text-[#aaa] tw-whitespace-nowrap">
                            {new Date(ev.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: '2-digit' })}
                          </td>
                          <td className="tw-px-4 tw-py-3">
                            <span
                              className="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-2.5 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium"
                              style={{ backgroundColor: typeInfo.bg, color: typeInfo.text }}
                            >
                              <i className={'fa ' + typeInfo.icon} style={{ fontSize: 10 }} />
                              {typeLabel}
                            </span>
                          </td>
                          <td className="tw-px-4 tw-py-3 tw-text-[#1a1a1a] dark:tw-text-white tw-truncate tw-max-w-[180px] tw-hidden md:tw-table-cell">
                            {ev.post ? ev.post.title : 'Deleted'}
                          </td>
                          <td className="tw-px-4 tw-py-3 tw-hidden sm:tw-table-cell">
                            {ev.buyer ? (
                              <button
                                onClick={function() { if (self.props.onOpenUserModal) self.props.onOpenUserModal(ev.buyer._id); }}
                                className="tw-bg-transparent tw-border-0 tw-p-0 tw-text-sm tw-cursor-pointer tw-font-medium hover:tw-underline"
                                style={{ color: '#D4A843' }}
                              >
                                {ev.buyer.userName}
                              </button>
                            ) : <span className="tw-text-[#999]">-</span>}
                          </td>
                          <td className="tw-px-4 tw-py-3 tw-hidden sm:tw-table-cell">
                            {ev.seller ? (
                              <button
                                onClick={function() { if (self.props.onOpenUserModal) self.props.onOpenUserModal(ev.seller._id); }}
                                className="tw-bg-transparent tw-border-0 tw-p-0 tw-text-sm tw-cursor-pointer tw-font-medium hover:tw-underline"
                                style={{ color: '#D4A843' }}
                              >
                                {ev.seller.userName}
                              </button>
                            ) : <span className="tw-text-[#999]">-</span>}
                          </td>
                          <td className="tw-px-4 tw-py-3 tw-text-right tw-font-semibold tw-whitespace-nowrap" style={{ color: ev.type === 'refund' || ev.type === 'partial_refund' ? '#EF4444' : '#1a1a1a' }}>
                            {ev.type === 'refund' || ev.type === 'partial_refund' ? '-' : ''}${(amount || 0).toFixed(2)}
                          </td>
                          <td className="tw-px-4 tw-py-3 tw-text-center">
                            <span className="tw-text-xs tw-font-medium tw-text-[#666] dark:tw-text-[#aaa]">
                              {ev.paymentMethod === 'paypal' ? (
                                <span><i className="fa fa-paypal" style={{ color: '#003087' }} /> PP</span>
                              ) : (
                                <span><i className="fa fa-cc-stripe" style={{ color: '#635BFF' }} /> Stripe</span>
                              )}
                            </span>
                          </td>
                          <td className="tw-px-4 tw-py-3 tw-text-center tw-hidden lg:tw-table-cell">
                            <span
                              className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium"
                              style={{ backgroundColor: statusColors.bg, color: statusColors.text }}
                            >
                              {ev.payoutStatus}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Pagination */}
            {this.state.pages > 1 && (
              <div className="tw-flex tw-items-center tw-justify-between tw-mt-4">
                <span className="tw-text-sm tw-text-[#999]">
                  Page {this.state.page} of {this.state.pages} ({this.state.total} total)
                </span>
                <div className="tw-flex tw-gap-2">
                  <button
                    disabled={this.state.page <= 1}
                    onClick={function() { var p = self.state.page - 1; self.setState({ page: p }, function() { self.fetchLedger(p); }); }}
                    className="tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-sm tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                  >
                    Prev
                  </button>
                  <button
                    disabled={this.state.page >= this.state.pages}
                    onClick={function() { var p = self.state.page + 1; self.setState({ page: p }, function() { self.fetchLedger(p); }); }}
                    className="tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-sm tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default AdminPaymentLedger;
